import { MetadataEntitiesClient } from "@api/apiClient";
import { useQuery } from "@tanstack/react-query";
import axios from "@api/axiosInstance";

const metadataClient = new MetadataEntitiesClient(undefined, axios);

const BENCHMARK_MODEL_TYPE = "BenchmarkModelType";

/** Query key for benchmark model types list (used for invalidation after add/update/delete). */
export const BENCHMARK_MODEL_TYPES_QUERY_KEY = ["benchmarkModelTypes", BENCHMARK_MODEL_TYPE] as const;

/**
 * Fetches Benchmark Model Types from metadata API (MetadataEntity with Type = BenchmarkModelType).
 * Sorted by name for display (e.g. dropdowns).
 */
export function useBenchmarkModelTypes(options?: { enabled?: boolean }) {
  return useQuery({
    ...options,
    queryKey: BENCHMARK_MODEL_TYPES_QUERY_KEY,
    queryFn: async () => {
      const list = await metadataClient.getMetaDataByType(BENCHMARK_MODEL_TYPE);
      return [...(list || [])].sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""));
    },
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
}
